import { POST, DELETE, GET } from './API';

const PATH_ROOT = 'U005';

export async function A01(
  userId: string,
  auditionId: string,
  lang: string,
  cancellation?: AbortSignal
) {
  return await POST(`${PATH_ROOT}/audition`, {
    user_id: userId,
    audition_id: auditionId,
    lang: lang,
    limit: 100,
    signal: cancellation,
  });
}

export type A02Output = {
  notifications: Array<{
    id: number;
    title: string;
    notice: string;
    published_at: string;
    file1: string;
    file2: string;
    file3: string;
    file4: string;
    file5: string;
  }>;
};
export async function A02(auditionId: string, lang: string, cancellation?: AbortSignal) {
  return await POST(`${PATH_ROOT}/notifications`, {
    audition_id: auditionId,
    lang: lang,
    limit: 100,
    signal: cancellation,
  });
}

export type A03Output = {
  messages: Array<{
    message_no: number;
    message: string;
    is_user: boolean;
    file: string;
    ins_dtm: string;
  }>;
};
export async function A03(userId: string, auditionId: string, cancellation?: AbortSignal) {
  return await POST(`${PATH_ROOT}/messages`, {
    user_id: userId,
    audition_id: auditionId,
    limit: 100,
    signal: cancellation,
  });
}

export async function A04(
  userId: string,
  auditionId: string,
  reason: string,
  declineKbn: string,
  examinationNo: number,
  examinationKbn: string,
  examination_s_no: number,
  result: string
) {
  return await DELETE(`${PATH_ROOT}/applicant`, {
    user_id: userId,
    audition_id: auditionId,
    limit: 100,
    reason: reason,
    decline_kbn: declineKbn,
    examination_no: examinationNo,
    examination_kbn: examinationKbn,
    examination_s_no: examination_s_no,
    result: result,
  });
}

export async function A05(
  userId: string,
  auditionId: string,
  filePath: string,
  cancellation?: AbortSignal
) {
  return await POST(`${PATH_ROOT}/attached_file`, {
    user_id: userId,
    audition_id: auditionId,
    file_path: filePath,
    signal: cancellation,
  });
}

export type A06Input = {
  lang: string;
  audition_id: string;
  consent_type: string;
};
export type A06Output = {
  consent: string;
};
export async function A06(input: A06Input, cancellation?: AbortSignal) {
  const param = new URLSearchParams();
  param.append('lang', input.lang);
  param.append('audition_id', input.audition_id);
  param.append('consent_type', input.consent_type);
  return await GET(`${PATH_ROOT}/audition_consent?${param.toString()}`, cancellation);
}
